import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { bindTrigger, PopupState } from 'material-ui-popup-state/hooks';
import { useTranslation } from 'react-i18next';

interface Props {
  popupState: PopupState;
  active?: boolean;
  'data-tour'?: string;
}

const FilterPopoverButton = ({ popupState, active = false, 'data-tour': dataTour }: Props) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('form.filters')}>
      <Badge color="primary" variant="dot" invisible={!active}>
        <IconButton
          {...bindTrigger(popupState)}
          aria-label={t('form.filters')}
          size="small"
          sx={{ flexShrink: 0 }}
          data-tour={dataTour}
        >
          <FilterAltIcon />
        </IconButton>
      </Badge>
    </Tooltip>
  );
};

export default FilterPopoverButton;
